/* EWU · Age gate +18 por producto.
   Se carga SOLO desde sections/ewu-age-gate.liquid cuando el producto tiene el
   tag configurado (por defecto 18plus).

   Es una barrera de experiencia de usuario, no una verificación de identidad.
   La confirmación se guarda en localStorage (clave ewu:age-gate) con fecha de
   vencimiento; si el navegador no permite storage, se recuerda solo durante la
   visita a la página. */
(function () {
  'use strict';

  var root = document.documentElement;

  /* Editor de temas: no se bloquea la página; el modal se previsualiza al
     seleccionar la sección "Age gate +18". */
  if (window.Shopify && window.Shopify.designMode) {
    var togglePreview = function (event, show) {
      var previewGate = event.target.querySelector && event.target.querySelector('[data-ewu-age-gate]');
      if (previewGate) previewGate.classList.toggle('ewu-age-gate--preview', show);
    };
    document.addEventListener('shopify:section:select', function (event) {
      togglePreview(event, true);
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      togglePreview(event, false);
    });
    return;
  }

  var gate = document.querySelector('[data-ewu-age-gate]');
  if (!gate || gate.dataset.ewuAgeGateReady === 'true') return;
  gate.dataset.ewuAgeGateReady = 'true';

  var STORAGE_KEY = gate.dataset.storageKey || 'ewu:age-gate';
  var REMEMBER_DAYS = parseInt(gate.dataset.rememberDays, 10) || 30;
  var DAY_MS = 24 * 60 * 60 * 1000;
  var FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var dialog = gate.querySelector('[role="dialog"]');
  var steps = gate.querySelectorAll('[data-ewu-age-gate-step]');
  var inertedElements = [];
  var confirmedInMemory = false;
  var isOpen = false;

  function isConfirmed() {
    if (confirmedInMemory) return true;
    try {
      var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      return Boolean(saved && saved.ok === true && saved.exp > Date.now());
    } catch (error) {
      return false;
    }
  }

  function remember() {
    confirmedInMemory = true;
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ ok: true, exp: Date.now() + REMEMBER_DAYS * DAY_MS })
      );
    } catch (error) {}
  }

  /* Deja inerte todo lo que no sea el modal: recorre los ancestros del gate y
     marca a sus hermanos. Solo se revierte lo que este script marcó. */
  function setBackgroundInert(makeInert) {
    if (!makeInert) {
      inertedElements.forEach(function (element) {
        element.removeAttribute('inert');
      });
      inertedElements = [];
      return;
    }

    var node = gate;
    while (node && node !== document.body && node.parentElement) {
      var parent = node.parentElement;
      Array.prototype.forEach.call(parent.children, function (sibling) {
        if (sibling === node || sibling.hasAttribute('inert')) return;
        if (/^(SCRIPT|STYLE|LINK|NOSCRIPT)$/.test(sibling.tagName)) return;
        sibling.setAttribute('inert', '');
        inertedElements.push(sibling);
      });
      node = parent;
    }
  }

  function visibleFocusables() {
    return Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (element) {
      return !element.closest('[hidden]') && element.getClientRects().length > 0;
    });
  }

  function focusWithoutScroll(element) {
    if (!element) return;
    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function showStep(name, moveFocus) {
    Array.prototype.forEach.call(steps, function (step) {
      var active = step.getAttribute('data-ewu-age-gate-step') === name;
      step.hidden = !active;
      if (!active) return;

      var title = step.querySelector('.ewu-age-gate__title');
      var text = step.querySelector('.ewu-age-gate__text');
      if (title) dialog.setAttribute('aria-labelledby', title.id);
      if (text) dialog.setAttribute('aria-describedby', text.id);
      if (moveFocus) focusWithoutScroll(title || dialog);
    });
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    root.classList.remove('ewu-age-ok');
    root.classList.add('ewu-age-gate-open');
    showStep('ask', false);
    setBackgroundInert(true);
    focusWithoutScroll(dialog);
  }

  function close() {
    isOpen = false;
    root.classList.add('ewu-age-ok');
    root.classList.remove('ewu-age-gate-open');
    setBackgroundInert(false);
    focusWithoutScroll(document.getElementById('MainContent'));
  }

  function sync() {
    if (isConfirmed()) {
      if (isOpen) close();
      else root.classList.add('ewu-age-ok');
    } else {
      open();
    }
  }

  gate.addEventListener('click', function (event) {
    var target = event.target.closest('[data-ewu-age-gate-yes], [data-ewu-age-gate-no], [data-ewu-age-gate-back]');
    if (!target) return;

    if (target.hasAttribute('data-ewu-age-gate-yes')) {
      remember();
      close();
      document.dispatchEvent(new CustomEvent('ewu:age-gate:confirmed'));
    } else if (target.hasAttribute('data-ewu-age-gate-no')) {
      showStep('denied', true);
      document.dispatchEvent(new CustomEvent('ewu:age-gate:denied'));
    } else {
      showStep('ask', true);
    }
  });

  /* Trampa de foco: Tab y Shift+Tab circulan solo dentro del modal. Escape no
     lo cierra a propósito: la persona tiene que responder. */
  document.addEventListener(
    'keydown',
    function (event) {
      if (!isOpen || event.key !== 'Tab') return;

      var focusables = visibleFocusables();
      if (!focusables.length) {
        event.preventDefault();
        focusWithoutScroll(dialog);
        return;
      }

      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var current = document.activeElement;
      var inside = dialog.contains(current) && current !== dialog && focusables.indexOf(current) !== -1;

      if (event.shiftKey && (!inside || current === first)) {
        event.preventDefault();
        focusWithoutScroll(last);
      } else if (!event.shiftKey && (!inside || current === last)) {
        event.preventDefault();
        focusWithoutScroll(first);
      }
    },
    true
  );

  /* Si algo externo (una app, por ejemplo) roba el foco, vuelve al modal. */
  document.addEventListener('focusin', function (event) {
    if (isOpen && !gate.contains(event.target)) focusWithoutScroll(dialog);
  });

  /* Respaldo: mientras no haya confirmación, no se envía ningún formulario de
     agregar al carrito desde esta página. */
  document.addEventListener(
    'submit',
    function (event) {
      if (!isOpen) return;
      var action = (event.target && event.target.getAttribute && event.target.getAttribute('action')) || '';
      if (action.indexOf('/cart/add') === -1) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  /* Página restaurada desde el historial (bfcache): se vuelve a evaluar. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) sync();
  });

  /* Confirmación hecha en otra pestaña: se refleja en esta. */
  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) sync();
  });

  sync();
})();
